import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import type { OrgResponse } from "@bw/shared/types/generated";

import { SectionTitle } from "./LaunchReadiness";

export function FinalDecision({
  org,
  actionPending,
  startReviewPending,
  approvePending,
  onStartReview,
  onApprove,
  onReject,
}: {
  org: OrgResponse;
  actionPending: boolean;
  startReviewPending: boolean;
  approvePending: boolean;
  onStartReview: () => void;
  onApprove: () => void;
  onReject: () => void;
}) {
  return (
    <Stack component="section" spacing={1.5}>
      <SectionTitle
        title="Final decision"
        detail="Approve only when the backend reports that every launch requirement is clear."
      />
      <Box>
        <Typography color="text.secondary" variant="body2">
          {org.can_approve
            ? "Approval is available for this application."
            : "Resolve the reported blockers before approving launch."}
        </Typography>
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          sx={{ flexWrap: "wrap", mt: 1.5 }}
        >
          {org.status === "pending" && (
            <Button
              size="small"
              variant="outlined"
              type="button"
              onClick={onStartReview}
              disabled={actionPending}
            >
              {startReviewPending ? "Starting…" : "Start review"}
            </Button>
          )}
          <Button
            size="small"
            color="success"
            variant="contained"
            type="button"
            onClick={onApprove}
            disabled={!org.can_approve || actionPending}
            sx={{ "&&": { pointerEvents: "auto" } }}
          >
            {approvePending ? "Approving…" : "Approve launch"}
          </Button>
          <Button
            size="small"
            color="error"
            variant="outlined"
            type="button"
            onClick={onReject}
            disabled={actionPending}
          >
            Reject application
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
}
